import { Box, Button, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ModalCard from '../ui/ModalCard';
import StatusIconCircle from '../ui/StatusIconCircle';
import InfoCallout from '../ui/InfoCallout';
import { MailCheckIcon } from '../icons';

interface ForgotPasswordEmailSentCardProps {
  email: string;
  onChangeEmail: () => void;
}

export default function ForgotPasswordEmailSentCard({ email, onChangeEmail }: ForgotPasswordEmailSentCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ModalCard title={t('resetLinkSent.cardTitle')}>
      <StatusIconCircle icon={<MailCheckIcon size={24} />} variant="accent" />

      <Typography variant="h3" component="h1">
        {t('resetLinkSent.headline')}
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        <Trans
          i18nKey="resetLinkSent.description"
          values={{ email }}
          components={{ strong: <Box component="span" sx={{ color: 'text.primary', fontWeight: 600 }} /> }}
        />
      </Typography>

      <InfoCallout title={t('resetLinkSent.hintTitle')} body={t('resetLinkSent.hintBody')} />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <Button
          type="button"
          variant="contained"
          fullWidth
          onClick={() => navigate('/login')}
          sx={(theme) => ({
            backgroundColor: theme.app.primary,
            color: theme.app.primaryForeground,
            '&:hover': { backgroundColor: theme.app.primaryHover },
          })}
        >
          {t('resetLinkSent.backToLogin')}
        </Button>
        <Button
          type="button"
          variant="text"
          onClick={onChangeEmail}
          sx={(theme) => ({
            color: theme.app.foreground,
            '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
          })}
        >
          {t('resetLinkSent.changeEmail')}
        </Button>
      </Box>
    </ModalCard>
  );
}
